import { Button, Grid, TextField } from "@material-ui/core"
import { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { addAdultosAction } from "../../../../../ducks/cambioPaqueteDuck"
import { ToastMessage } from "../../../../../global/ToastMessage"
const FieldAdultos = (props) => {
    const { cantidadAdultos, listaItems, clavePaquete } = useSelector(store => store.cambiosPaquete)
    const { cliente } = useSelector(store => store.cambios)
    const [editar, setEditar] = useState(false)
    const dispatch = useDispatch()
    const handleChange = (event) => {
        dispatch(addAdultosAction({ cantidad: event.target.value }))
    }
    const handleGuardar = () => {
        hangdleClickEditar()
    }
    const hangdleClickEditar = () => {
        setEditar(!editar)
    }
    const hangdleClickCancelar = () => {
        setEditar(!editar)
    }
    return (
        <div>
            <Grid container>
                <Grid item xs={12}>
                    <div style={{ margin: "0.5rem 0", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <TextField
                            disabled={!editar || clavePaquete === "0"}
                            value={cantidadAdultos}
                            style={{ width: "100%" }}
                            id={`outlined-number-Adultos`}
                            label="Adultos"
                            name="adultos"
                            onChange={handleChange}
                            type="number"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                inputProps: { min: 0, max: 10 }
                            }}
                            variant="outlined"
                        />
                        {
                            (!editar) &&
                            <Button
                                style={{ margin: "0 2%" }}
                                variant="contained"
                                color="primary"
                                onClick={hangdleClickEditar}
                                disabled={clavePaquete === "0"}
                            >
                                Editar
                            </Button>
                        }
                        {
                            (editar) &&
                            <div style={{ margin: "0 2%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Button
                                    style={{ margin: "0 2%" }}
                                    variant="contained"
                                    color="primary"
                                    disabled={cantidadAdultos === 0}
                                    onClick={handleGuardar}
                                >
                                    Guardar
                                </Button>
                                <Button
                                    style={{ margin: "0 2%" }}
                                    variant="contained"
                                    color="default"
                                    onClick={hangdleClickCancelar}
                                >
                                    Cancelar
                                </Button>
                            </div>
                        }
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}
export default FieldAdultos